<template>
  <div class="main-container">
    <movie-hero :ticket="firstTicket" class="small"></movie-hero>
    <movies-data :seasons="seasons" :tickets="tickets"></movies-data>
  </div>
</template>

<script>
import MovieHero from '@/components/modules/Movie/MovieHero.vue'
import MoviesData from '@/components/modules/Program/MoviesData.vue'
import {groupBy, transform, get} from 'lodash-es'

export default {
  head: function () {
    return {
      ...this.$route.meta.head,
      ...{
        title: {
          inner: get(this.pageMeta, 'metaTitle', ''),
          separator: ' ',
          complement: ' '
        },
        meta: [
          {name: 'description', content: get(this.pageMeta, 'metaDescription', '')},
          {
            name: 'application-name', content: this.$route.meta.head.meta.find((element) => {
              if (element.name == 'application-name') return element
            }).content
          },
          {name: 'twitter:title', content: get(this.pageMeta, 'metaTitle', '')},
          {name: 'twitter:image', content: get(this.pageMeta, 'metaImage', '')},
          {name: 'twitter:description', content: get(this.pageMeta, 'metaDescription', '')},
          {property: 'og:title', content: get(this.pageMeta, 'metaTitle', '')},
          {property: 'og:image', content: get(this.pageMeta, 'metaImage', '')},
          {property: 'og:description', content: get(this.pageMeta, 'metaDescription', '')}
        ]
      }
    }
  },
  components: {MovieHero, MoviesData},
  data() {
    return {
      pageMeta: null,
      firstTicket: null,
      tickets: null,
      seasons: []
    }
  },
  methods: {
    getData: function (season) {
      var vm = this
      this.tickets = null
      let slug = season ? '/' + season : ''
      this.$http.get('/projections' + slug).then(response => {
        this.tickets = response.data.data
        if (response.data.meta.seasons) {
          this.seasons = response.data.meta.seasons
        }
        this.firstTicket = this.getFirstAvailableTicket(this.tickets)
      })
        .catch((error) => {
          vm.$event.$emit('alert', {alertId: 0})
        })
    },
    getFirstAvailableTicket: function (tickets) {
      for (let i in tickets) {
        for (let j in tickets[i].items) {
          if (tickets[i].items[j].afp) {
            return tickets[i].items[j]
          }
        }
      }
      return {
        'movie': {
          't': 'Programm',
          'm': {
            'd': '/storage/assets/images/kontakt.jpg'
          }
        }
      }
    }
  },
  mounted () {
    let year = this.$route.params.year

    if (year < 2010 || year > 2025) {
      year = 2025
    }

    this.getData(year)

    this.$event.$on('seasonChange', (season) => {
      this.$event.$emit('userinteraction', {item: 'filter', from: this.$route.path, label: season})
      this.routePush('/programm/' + season, {})
      this.getData(season)
    })

    this.$http.get('/single/programm').then(response => {
      this.pageMeta = response.data.meta;
      console.log(this.pageMeta);
      if (this.$route.hash) this.$event.$emit('move2anchor', this.$route.hash);
      this.$emit('updateHead');
    });
  }
}
</script>

<style lang="scss" scoped>
.main-container {
  overflow: hidden;
  position: relative;
  background-color: white;
}
</style>



// WEBPACK FOOTER //
// src/components/layout/Program.vue